export const loggedInValue = () => {
  return JSON.parse(sessionStorage.getItem("loggedIn"));
}

export const isSuperuserValue = () => {
  return JSON.parse(sessionStorage.getItem("isSuperuser"));
}

export const isStandardUserValue = () => {
  return JSON.parse(sessionStorage.getItem("isStandardUser"));
}